// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type ListEmployeeAlertReasonTypesQueryVariables = Types.Exact<{ [key: string]: never }>;

export type ListEmployeeAlertReasonTypesQuery = { __typename?: 'Query' } & {
  listEmployeeAlertReasonTypes: Array<
    { __typename?: 'EmployeeAlertReasonTypeWithDisplayName' } & Pick<
      Types.EmployeeAlertReasonTypeWithDisplayName,
      'value' | 'displayName' | 'priority'
    >
  >;
};

export const ListEmployeeAlertReasonTypesDocument = /*#__PURE__*/ gql`
    query listEmployeeAlertReasonTypes {
  listEmployeeAlertReasonTypes {
    value
    displayName
    priority
  }
}
    `;

/**
 * __useListEmployeeAlertReasonTypesQuery__
 *
 * To run a query within a React component, call `useListEmployeeAlertReasonTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEmployeeAlertReasonTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEmployeeAlertReasonTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListEmployeeAlertReasonTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<ListEmployeeAlertReasonTypesQuery, ListEmployeeAlertReasonTypesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListEmployeeAlertReasonTypesQuery, ListEmployeeAlertReasonTypesQueryVariables>(
    ListEmployeeAlertReasonTypesDocument,
    options,
  );
}
export function useListEmployeeAlertReasonTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListEmployeeAlertReasonTypesQuery,
    ListEmployeeAlertReasonTypesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListEmployeeAlertReasonTypesQuery, ListEmployeeAlertReasonTypesQueryVariables>(
    ListEmployeeAlertReasonTypesDocument,
    options,
  );
}
// @ts-expect-error
export function useListEmployeeAlertReasonTypesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListEmployeeAlertReasonTypesQuery,
    ListEmployeeAlertReasonTypesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListEmployeeAlertReasonTypesQuery, ListEmployeeAlertReasonTypesQueryVariables>;
export function useListEmployeeAlertReasonTypesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListEmployeeAlertReasonTypesQuery, ListEmployeeAlertReasonTypesQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ListEmployeeAlertReasonTypesQuery | undefined,
  ListEmployeeAlertReasonTypesQueryVariables
>;
export function useListEmployeeAlertReasonTypesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListEmployeeAlertReasonTypesQuery, ListEmployeeAlertReasonTypesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListEmployeeAlertReasonTypesQuery, ListEmployeeAlertReasonTypesQueryVariables>(
    ListEmployeeAlertReasonTypesDocument,
    options,
  );
}
export type ListEmployeeAlertReasonTypesQueryHookResult = ReturnType<typeof useListEmployeeAlertReasonTypesQuery>;
export type ListEmployeeAlertReasonTypesLazyQueryHookResult = ReturnType<
  typeof useListEmployeeAlertReasonTypesLazyQuery
>;
export type ListEmployeeAlertReasonTypesSuspenseQueryHookResult = ReturnType<
  typeof useListEmployeeAlertReasonTypesSuspenseQuery
>;
